const version = "7.18.1";
export {
  version
};
//# sourceMappingURL=package.json.js.map
